import InlineIcon from '../../../../../components/InlineIcon/InlineIcon';
import Paragraph from '../../../../../components/Paragraph/Paragraph';
import Row from '../../../../../components/Row/Row';
import Stack from '../../../../../components/Stack/Stack';
import BoatModelSpec from '../../../../types/BoatModelSpec';

import bulletIcon from './graphics/bullet.svg?raw';
import topSpeedIcon from './graphics/topSpeed.svg?raw';

const typeToIconMap: Record<BoatModelSpec['type'], string> = {
    TopSpeed: topSpeedIcon,
    Custom: bulletIcon,
};

const labelForSpec = (spec: BoatModelSpec) => {
    switch (spec.type) {
        case 'TopSpeed':
            return `${spec.value.speed} ${spec.value.unit}`;

        case 'Custom':
            return spec.value.label;
    }

    return '?';
};

type BoatModelSpecsProps = { specs: Array<BoatModelSpec> };

const BoatModelSpecs = ({ specs }: BoatModelSpecsProps) => {
    return (
        <Stack space="small">
            {specs.map((spec, index) => (
                <Row vertical="top" key={index} space="small">
                    <InlineIcon src={typeToIconMap[spec.type]} />
                    {spec.type === 'Custom' ? (
                        <Paragraph>{labelForSpec(spec)}</Paragraph>
                    ) : (
                        <Row horizontal="justify" flex>
                            <Paragraph>{spec.type}</Paragraph>
                            <Paragraph>{labelForSpec(spec)}</Paragraph>
                        </Row>
                    )}
                </Row>
            ))}
        </Stack>
    );
};

export default BoatModelSpecs;
